export const css = {
	root: '_3f-B6LDM',
	' _key': 'ascm-theme/ascm/variants/ctsc'
};

export default css;
